import i18next from 'i18next';
import { LOCALE_KEY } from '../consts/languages';
import { PACK } from '../consts/packs';

/**
 * Capitalize first letter of string
 */
export const capitalize = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Replace underscores with spaces in string
 */
export const humanize = (arg: any) => {
  if (typeof arg === 'number') return arg.toString();
  if (typeof arg !== 'string') return '';
  return capitalize(arg.replace(/_/g, ' '));
};

/**
 * Delete spaces at start and end
 */
export const trim = (value: any) => {
  if (typeof value === 'string') return value.trim();
  return value;
};

/**
 * Finds out current frontend pack of the module
 *
 * @returns {string}
 */
export const getCurrentPack = (): PACK => {
  const rootRoute = window.location.pathname.split('/')[1];
  return rootRoute as PACK;
};

/**
 * Formats phone number
 */
export const getPhone = ({
  phone_code,
  phone,
}: {
  phone_code?: { code: string | number } | null;
  phone?: string | number | null;
}) => (phone ? `${phone_code?.code || ''}${phone || ''}` : null);

/**
 * Combines parts of input name
 */
export const getInputName = (...parts: string[]) => parts.join('.');

export interface AddressParams {
  address: string;
  city: string;
  state: string;
}

export const getUnitedAddress = ({ address, city, state }: AddressParams): string => {
  return `${address}, ${city}, ${state}`;
};

interface UserNameParams {
  first_name: string | null;
  last_name: string | null;
}

export const getUserNameValue = (user: UserNameParams | null): string => {
  if (!user) return '';
  const { first_name, last_name } = user;
  if (!first_name && !last_name) return '';
  return `${first_name || ''} ${last_name || ''}`.trim();
};

export const getLocalizedLabel = (label: string) => i18next.t(label, { lng: LOCALE_KEY.ENGLISH }).toLowerCase();